import { observer, useLocalObservable } from 'mobx-react';
import { Tooltip } from 'react-tooltip';
import { getTooltipId } from '../../utils/utils';
import { ICON_BUTTON_ICONS } from '../buttons/IconButton';
import { useMemo } from 'react';

const WarningBadge = observer(
  ({
    badgeId = '',
    label = 'Warning',
    tooltipContent = '',
    tooltipPosition = 'bottom-end',
    badgeClassName = ''
  }) => {
    const state = useLocalObservable(() => ({
      badgeId: `warning-badge-${getTooltipId()}`
    }));

    const className = useMemo(
      () => ['warning-badge', 'noselect', badgeClassName].filter(Boolean).join(' '),
      [badgeClassName]
    );

    const computedBadgeId = useMemo(() => badgeId || state.badgeId, [state.badgeId, badgeId]);

    return (
      <>
        <div className={className} id={computedBadgeId}>
          <div className="warning-badge-icon-wrap">
            <img src={ICON_BUTTON_ICONS.EXCLAMATAION_CIRCLE} alt="!" />
          </div>
          <div className="warning-badge-label">{label}</div>
        </div>

        {!!tooltipContent && (
          <Tooltip
            anchorSelect={`#${computedBadgeId}`}
            multiline
            variant="warning"
            place={tooltipPosition}
            opacity={1}
            className="warning-badge-tooltip">
            {tooltipContent}
          </Tooltip>
        )}
      </>
    );
  }
);

export default WarningBadge;
